import {
  Autocomplete,
  Button,
  Divider,
  Drawer,
  Fade,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  Stack,
  TextField,
  Typography,
  createSvgIcon,
  useTheme,
  Tooltip,
  Chip,
  alpha,
  InputAdornment,
  CircularProgress,
  Checkbox,
} from "@mui/material";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import IconTransform from "../iconsElement";
import {
  AnimationOutlined,
  CancelOutlined,
  DeleteOutline,
  DoubleArrowOutlined,
  LineStyle,
  SaveOutlined,
  ShapeLineOutlined,
  Timeline,
  ViewInArOutlined,
} from "@mui/icons-material";
import { ReactComponent as LinkedSvg } from "../../../assets/easyMaps/iconsSvg/Linked.svg";
import { ReactComponent as CapacitySvg } from "../../../assets/easyMaps/iconsSvg/capacidade.svg";
import { ReactComponent as ItemSVG } from "../../../assets/easyMaps/iconsSvg/item.svg";
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined";
import { forwardRef, useEffect, useState, useImperativeHandle } from "react";
import ForkRightIcon from "@mui/icons-material/ForkRight";
import NearMeIcon from "@mui/icons-material/NearMe";
import { LoadingButton } from "@mui/lab";
import { VirtualizedListbox } from "../vitualizationAutoComplete";
import extractInterfaces from "../../../utils/easyMaps/extractInterfaces";
import extractInterfaceSelected from "../../../utils/easyMaps/extractInterfaceSelected";
import extratcItensFromInterface from "../../../utils/easyMaps/extractItensFromInterface";
import {
  extractItemIsNotTrafficNotPower,
  filterItemIsNotTrafficNotPower,
} from "../../../utils/easyMaps/itensIsNotTrafficNotPower";
import useStyles from "./styles";
import { use } from "react";

const lineTypes = ["reta", "ortogonal", "curvada"];
const animationTypes = ["pontilhada", "tracejada"];

const EnlaceSideBarEasyMaps = forwardRef(
  (
    {
      setEdgeSelected = () => {},
      setOpenAlertModal = () => {},
      connection = null,
      setConnection = () => {},
      edgeSelected,
      setSnackbar,
      api,
      produtos,
      elements,
      iconsElement,
      saveConnection,
      handleDelete = () => {},
      changeConnection,
      fullScreem = false,
      autoRouting = () => {},
      cleanRouting = () => {},
      loadRouting = false,
      setLoadRouting = () => {},
      tipoMapa = 0,
      checkChanges,
      setCheckChanges,
      loadingButton,
      typeElement = "Host",
    },
    ref
  ) => {
    const [line, setLine] = useState("reta");
    const [itens, setItens] = useState([]);
    const [link, setLink] = useState("");
    const [hostId, setHostId] = useState("");
    const [itemConnection, setItemConnection] = useState([]);
    const [otherItensConnection, setOtherItensConnection] = useState([]);
    const [capacidade, setCapacidade] = useState("");
    const [iconsElementPair, setIconsElementPair] = useState([]);
    const [animation, setAnimation] = useState("");
    const [loading, setLoading] = useState(false);
    const [elementsPair, setElementsPair] = useState([]);
    //potencia
    const [limiteSuperiorPowerRX, setLimiteSuperiorPowerRX] = useState(0);
    const [limiteInferiorPowerRX, setLimiteInferiorPowerRX] = useState(0);
    const [limiteSuperiorPowerTX, setLimiteSuperiorPowerTX] = useState(0);
    const [limiteInferiorPowerTX, setLimiteInferiorPowerTX] = useState(0);
    const [flagLimiteAutomatico, setFlagLimiteAutomatico] = useState(true);
    //interfaces
    const [interfaces, setInterfaces] = useState([]);
    const [interfaceSelected, setInterfaceSelected] = useState(null);
    //const previousChange = usePrevious(positionHandlers);
    const theme = useTheme();
    const CapacityIcon = createSvgIcon(
      <CapacitySvg height="100%" width="100%" />
    );
    const LinkedIcon = createSvgIcon(<LinkedSvg height="80%" width="80%" />);
    const ItemIcon = createSvgIcon(<ItemSVG height="90%" width="90%" />);
    const styles = useStyles(theme, fullScreem);

    useImperativeHandle(ref, () => ({
      update() {
        handleSave();
      },
    }));

    // useEffect(() => {
    //   if (
    //     flagLimiteAutomatico == false ||
    //     itens.length == 0 ||
    //     interfaceSelected == null
    //   )
    //     return;
    //   let itensInterface = extratcItensFromInterface(interfaceSelected, itens);
    //   let itensLimit = itensInterface.filter((i) => i.key_?.includes("Thold"));
    //   console.log("itensLimit", itensLimit, itensInterface);
    // }, [itens, flagLimiteAutomatico, interfaceSelected]);

    useEffect(() => {
      if (connection != undefined) {
        let imgsPair = [];
        const reference = elements.find(
          ({ id }) => id == connection?.referenceId
        );
        const destination = elements.find(
          ({ id }) => id == connection?.destinationId
        );
        let findPair = [reference, destination];
        imgsPair = [reference?.img, destination?.img];
        if (Array.isArray(findPair) && findPair.length === 2) {
          setElementsPair(findPair);
          setIconsElementPair([
            iconsElement?.find((icon) => imgsPair[0] === icon?.id),
            iconsElement?.find((icon) => imgsPair[1] === icon?.id),
          ]);
        }
        //potencias
        setLimiteSuperiorPowerRX(
          connection?.config?.limiteSuperiorPowerRX ?? 0
        );
        setLimiteInferiorPowerRX(
          connection?.config?.limiteInferiorPowerRX ?? 0
        );
        setLimiteSuperiorPowerTX(
          connection?.config?.limiteSuperiorPowerTX ?? 0
        );
        setLimiteInferiorPowerTX(
          connection?.config?.limiteInferiorPowerTX ?? 0
        );
        setFlagLimiteAutomatico(
          connection?.config?.flagLimiteAutomatico ?? true
        );
        setCapacidade(connection?.config?.capacidade ?? "");
        setAnimation(connection?.config?.animation ?? "desativada");
        setLine(connection?.config?.type || lineTypes[0]);
        // devido a possibilidade de criar conexões sem itens
        let hostConnId = connection?.config?.hostOriginId; // as novas conexões carregaram esse campo (cardConnection)
        if (!hostConnId) {
          //verifica o host pelos itens da conexão
          if (Array.isArray(connection.item) && connection.item.length > 0) {
            setHostId(connection?.item[0]?.hostOriginId);
          } else {
            let elementoReference = elements.find(
              (a) => a.id == connection.referenceId
            );
            if (elementoReference?.tipo == 0) {
              setHostId(
                elementoReference?.elementConfig?.config?.hosts[0]?.hostid
              );
            }
            // Aqui fica sério pq em mapas ou pops temos muitos hosts e não dá para saber qual deles é a origim se nã tiver itens ou o hostOriginId,
            //nesse caso os usuarios precisaram recolocar o host de origem na conexão para que carregem o campo hostOriginId
          }
        } else {
          setHostId(hostConnId);
        }
        const produtoId = elements.find(
          (ele) => ele.id == connection?.referenceId
        )?.elementConfig?.config?.produtoId;
        let link = null;
        const produto = produtos.find((pro) => pro.id == produtoId);
        if (
          Array.isArray(produto?.AcessoLink) &&
          produto?.AcessoLink.length > 0
        )
          setLink(produto.AcessoLink[0]?.link);
      }
    }, [connection?.id]);

    useEffect(() => {
      // Early return se não houver itens
      if (!itens?.length) {
        setInterfaces([]);
        setInterfaceSelected(null);
        setOtherItensConnection([]);
        return;
      }

      const uniqueInterfaces = extractInterfaces(itens);
      const interfaceSelected = extractInterfaceSelected(
        connection?.item,
        uniqueInterfaces
      );
      const otherItems = extractItemIsNotTrafficNotPower(itens, connection);

      // Atualiza os estados
      if (interfaceSelected) setInterfaceSelected(interfaceSelected);
      if (uniqueInterfaces.length) setInterfaces(uniqueInterfaces);
      if (otherItems.length) setOtherItensConnection(otherItems);
    }, [itens]);

    useEffect(() => {
      if (hostId == "" || hostId == null || link == "" || !connection) return;
      getItens();
    }, [link, hostId]);

    useEffect(() => {
      if (connection === null) {
        clearMemory();
      }
    }, [connection]);

    function clearMemory() {
      setLoadRouting(false);
      setLine("reta");
      setItens([]);
      setLink("");
      setHostId("");
      setItemConnection([]);
      setOtherItensConnection([]);
      setCheckChanges(false);
    }
    function close() {
      setConnection(null);
      setEdgeSelected(null);
      clearMemory();
    }
    async function getItens() {
      try {
        setItemConnection([]);
        setOtherItensConnection([]);
        setLoading(true);

        const response = await api.post("/easyMaps/zabbix/itens", {
          link: link,
          hostids: hostId,
        });

        if (response.data.status === "Error") {
          setSnackbar({
            children: "Error: Não foi possível buscar os hosts",
            severity: "error",
          });
        } else {
          let responseItens = response.data;

          setItens([
            ...new Map(
              responseItens.map((item) => [item.itemid, item])
            ).values(),
          ]);
        }
      } catch (error) {
        console.error(error);
        setSnackbar({
          children: "Error: Não foi possível se conectar com o servidor",
          severity: "error",
        });
      } finally {
        setLoading(false);
      }
    }
    const handleSave = () => {
      let updateConnection = connection;
      const referenceElem = elements.find(
        ({ id }) => id === updateConnection?.referenceId
      );
      const acessoProdutoId = referenceElem?.elementConfig?.config?.produtoId;
      updateConnection.item = [
        ...extratcItensFromInterface(interfaceSelected, itens),
        ...otherItensConnection,
      ].map((item) => ({
        itemId: item?.itemid || null,
        itemName: item?.name || null,
        hostOriginId: item?.hostid || null,
        acessoProdutoId: acessoProdutoId || null,
        key_: item?.key_ || null,
      }));

      if (edgeSelected)
        saveConnection(
          updateConnection,
          edgeSelected,
          line,
          capacidade,
          animation,
          connection.config?.hostOriginId,
          flagLimiteAutomatico,
          limiteSuperiorPowerRX,
          limiteInferiorPowerRX,
          limiteSuperiorPowerTX,
          limiteInferiorPowerTX
        );
      else
        saveConnection(
          updateConnection,
          null,
          line,
          capacidade,
          animation,
          connection.config?.hostOriginId,
          flagLimiteAutomatico,
          limiteSuperiorPowerRX,
          limiteInferiorPowerRX,
          limiteSuperiorPowerTX,
          limiteInferiorPowerTX
        );
    };

    function Session({ title }) {
      return (
        <Stack mb={0.5}>
          <Typography sx={styles.title}>{title}</Typography>
          <Divider />
        </Stack>
      );
    }
    function HeaderTitle({ title, Icon }) {
      return (
        <Stack direction="row" gap={2} alignItems="center">
          <Icon
            color="primary"
            sx={{
              fontSize: "28px",
            }}
          />
          <Typography sx={styles.text} ml="-5px">
            {title}
          </Typography>
        </Stack>
      );
    }

    return (
      <Drawer
        key={connection?.id}
        variant="persistent"
        anchor={"right"}
        open={!!connection}
        //onClose={() => close()}
        sx={styles.drawer}
      >
        <Paper sx={styles.header}>
          <Stack width="100%" alignItems="center" justifyContent={"center"}>
            <IconTransform
              img={iconsElementPair.length > 0 ? iconsElementPair[0]?.img : ""}
              size="35px"
            />
            <Tooltip title={elementsPair[0]?.titulo}>
              <Typography
                sx={{
                  fontSize: "14px",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                {elementsPair[0]?.titulo.length > 30
                  ? elementsPair[0]?.titulo.substring(0, 30) + "..."
                  : elementsPair[0]?.titulo}
              </Typography>
            </Tooltip>
          </Stack>

          <DoubleArrowOutlined color="primary" sx={{ fontSize: "30px" }} />

          {/* <SvgArrow style={{ width: "200px" }} /> */}
          <Stack width="100%" alignItems="center" justifyContent={"center"}>
            <IconTransform
              img={
                iconsElementPair.length > 0
                  ? iconsElementPair[1]?.img ?? iconsElementPair[0]?.img
                  : ""
              }
              size="35px"
            />
            <Tooltip title={elementsPair[1]?.titulo}>
              <Typography
                sx={{
                  fontSize: "14px",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                {elementsPair[1]?.titulo.length > 30
                  ? elementsPair[1]?.titulo.substring(0, 30) + "..."
                  : elementsPair[1]?.titulo}
              </Typography>
            </Tooltip>
          </Stack>
        </Paper>

        {!!loading && (
          <Stack
            gap={2}
            sx={{
              maxHeight: "80vh",
              overflow: "auto",
            }}
          >
            <Stack sx={{ width: "100%" }}>
              <LinearProgress />
            </Stack>
          </Stack>
        )}
        {!loading && (
          <>
            <Stack sx={styles.container}>
              <Session title="Configurações Gerais" />

              <HeaderTitle
                title={"Interface do host de origem"}
                Icon={LinkedIcon}
              />
              <Autocomplete
                disableCloseOnSelect
                key="interfaceAutocomplete"
                id="interfaceHost"
                size="small"
                color="primary"
                options={interfaces}
                getOptionLabel={(option) => {
                  if (Array.isArray(option) || !option) return {};
                  return option.description
                    ? option.interface + " - " + option.description
                    : option.interface;
                }}
                isOptionEqualToValue={(option, value) =>
                  option.interface == value.interface
                }
                ListboxComponent={VirtualizedListbox}
                renderOption={(props, option, { selected }) => (
                  <li
                    {...props}
                    style={{ padding: "0px" }}
                    key={option.interface}
                  >
                    <Tooltip
                      title={
                        option?.description
                          ? option?.interface + " - " + option?.description
                          : option?.interface
                      }
                      placement="left-start"
                      arrow
                    >
                      <Stack sx={styles.stackOption}>
                        <Checkbox checked={selected} />
                        <span style={styles.textoLimitado}>
                          {option?.description
                            ? option?.interface + " - " + option?.description
                            : option?.interface}
                        </span>
                      </Stack>{" "}
                    </Tooltip>
                  </li>
                )}
                value={interfaceSelected || null}
                onChange={(event, newValue) => {
                  setInterfaceSelected(newValue);
                  setCheckChanges(true);
                }}
                renderInput={(params) => (
                  <Tooltip
                    title={params.inputProps.value}
                    placement="left"
                    arrow
                  >
                    <TextField
                      key="interfaceText"
                      {...params}
                      sx={styles.textField}
                      color="primary"
                      placeholder="Interface"
                      helperText={
                        itens?.length == 0 && "Esse elemento não contém itens"
                      }
                    />
                  </Tooltip>
                )}
              />

              <HeaderTitle title={"Adicione outros itens"} Icon={ItemIcon} />

              <Autocomplete
                key="autoc-02"
                multiple
                disableCloseOnSelect
                disablePortal
                id="itensnoTraffic"
                size="small"
                color="primary"
                options={filterItemIsNotTrafficNotPower(itens)}
                value={[...otherItensConnection] || []}
                onChange={(event, newValue) => {
                  setOtherItensConnection(newValue);
                  setCheckChanges(true);
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Tooltip title={option.name} key={index + "tool"}>
                      <Chip label={option.name} {...getTagProps({ index })} />
                    </Tooltip>
                  ))
                }
                ListboxComponent={VirtualizedListbox}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ padding: "0px" }} key={option.itemid}>
                    <Tooltip title={option.name} placement="left-start">
                      <Stack sx={styles.stackOption}>
                        <Checkbox checked={selected} />
                        <span style={styles.textoLimitado}>{option.name}</span>
                      </Stack>{" "}
                    </Tooltip>
                  </li>
                )}
                getOptionLabel={(option) => option?.name}
                isOptionEqualToValue={(option, value) =>
                  option?.itemid == value?.itemid
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    color="primary"
                    placeholder="Outros itens"
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        startAdornment: (
                          <Stack
                            direction={"row"}
                            justifyContent={"center"}
                            alignItems={"center"}
                          >
                            <InputAdornment position="start">
                              <ViewInArOutlined
                                sx={{
                                  color: theme.palette.color.bgIcon,
                                  fontSize: "20px",
                                }}
                              />
                            </InputAdornment>
                            <Stack
                              sx={{
                                maxWidth: "200px",
                              }}
                            >
                              {params.InputProps.startAdornment}
                            </Stack>
                          </Stack>
                        ),
                      },
                    }}
                  />
                )}
              />

              <HeaderTitle
                title={"Selecione a animação"}
                Icon={AnimationOutlined}
              />

              <TextField
                select
                size="small"
                value={animation}
                onChange={(event) => {
                  setCheckChanges(true);
                  setAnimation(event.target.value);
                }}
                placeholder="animação"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <LineStyle
                          sx={{
                            ml: "-10px",
                            color: theme.palette.color.bgIcon,
                            fontSize: "22px",
                          }}
                        />
                      </InputAdornment>
                    ),
                  },
                }}
              >
                <MenuItem value="desativada">
                  <em>Desativada</em>
                </MenuItem>
                {animationTypes?.map((type, index) => (
                  <MenuItem key={index} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
              {tipoMapa == 1 && (
                <>
                  <HeaderTitle
                    title={"Selecione o tipo de Linha"}
                    Icon={ShapeLineOutlined}
                  />

                  <TextField
                    select
                    size="small"
                    value={line}
                    onChange={(event) => {
                      setLine(event.target.value);
                      changeConnection(connection.id, {
                        type: event.target.value,
                      });
                      setCheckChanges(true);
                    }}
                    placeholder="Tipo de linha"
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Timeline
                              sx={{
                                ml: "-10px",
                                color: theme.palette.color.bgIcon,
                                fontSize: "22px",
                              }}
                            />
                          </InputAdornment>
                        ),
                      },
                    }}
                  >
                    {lineTypes?.map((type, index) => (
                      <MenuItem key={index} value={type}>
                        {/* <Camera /> */}
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>
                </>
              )}

              {tipoMapa == 0 && (
                <>
                  <HeaderTitle
                    title={" Roteamento automático"}
                    Icon={ForkRightIcon}
                  />
                  <Stack gap={1} direction={"row"}>
                    <Button
                      loading={loading}
                      sx={styles.buttonRoter}
                      disabled={loadRouting}
                      onClick={() => {
                        setCheckChanges(true);
                        autoRouting(connection);
                      }}
                    >
                      {!loadRouting ? (
                        <>
                          <NearMeIcon />
                          <Typography sx={styles.textButtonRoter}>
                            Encontrar rota
                          </Typography>
                        </>
                      ) : (
                        <CircularProgress size={30} color="primary" />
                      )}
                    </Button>
                    <Button
                      sx={styles.buttonRoter}
                      disabled={loadRouting}
                      onClick={() => {
                        setCheckChanges(true);
                        cleanRouting(connection);
                      }}
                    >
                      <CleaningServicesOutlinedIcon />
                      <Typography sx={styles.textButtonRoter}>
                        Limpar Pontos
                      </Typography>
                    </Button>
                  </Stack>
                </>
              )}
              <Session title="Configurações de Tráfego" />

              <HeaderTitle
                title={"Informe a capacidade máxima (Gb)"}
                Icon={CapacityIcon}
              />
              <TextField
                size="small"
                value={capacidade}
                onChange={(e) => {
                  setCapacidade(e.target.value);
                  setCheckChanges(true);
                }}
              />
              <Session title="Configurações de Potência" />
              <Stack
                direction="row"
                alignItems="center"
                gap={0.5}
                mb={flagLimiteAutomatico ? 1 : 0}
              >
                <Checkbox
                  checked={flagLimiteAutomatico}
                  onChange={(event) =>
                    setFlagLimiteAutomatico(event.target.checked)
                  }
                  sx={{ p: 0 }}
                />
                <Typography sx={styles.text}>
                  Usar limiares do Zabbix
                </Typography>
              </Stack>
              {!flagLimiteAutomatico && (
                <>
                  <Stack gap={0.5}>
                    <HeaderTitle
                      title={"Limite Superior TX (dBm)"}
                      Icon={SignalCellularAltIcon}
                    />
                    <TextField
                      placeholder="Limite Superior TX"
                      size="small"
                      value={limiteSuperiorPowerTX}
                      type="number"
                      onChange={(event) => {
                        setLimiteSuperiorPowerTX(event.target.value);
                      }}
                      sx={styles.textField}
                    />
                  </Stack>
                  <Stack gap={0.5}>
                    <HeaderTitle
                      title={"Limite Inferior TX (dBm)"}
                      Icon={SignalCellularAltIcon}
                    />
                    <TextField
                      placeholder="Limite Inferior TX"
                      size="small"
                      value={limiteInferiorPowerTX}
                      type="number"
                      onChange={(event) => {
                        setLimiteInferiorPowerTX(event.target.value);
                      }}
                      sx={styles.textField}
                    />
                  </Stack>
                  <Stack gap={0.5}>
                    <HeaderTitle
                      title={"Limite Superior RX (dBm)"}
                      Icon={SignalCellularAltIcon}
                    />
                    <TextField
                      placeholder="Limite Superior RX"
                      size="small"
                      value={limiteSuperiorPowerRX}
                      type="number"
                      onChange={(event) => {
                        setLimiteSuperiorPowerRX(event.target.value);
                      }}
                      sx={styles.textField}
                    />
                  </Stack>
                  <Stack gap={0.5}>
                    <HeaderTitle
                      title={"Limite Inferior RX (dBm)"}
                      Icon={SignalCellularAltIcon}
                    />
                    <TextField
                      placeholder="Limite Inferior RX"
                      size="small"
                      value={limiteInferiorPowerRX}
                      type="number"
                      onChange={(event) => {
                        setLimiteInferiorPowerRX(event.target.value);
                      }}
                      sx={styles.textField}
                    />
                  </Stack>
                </>
              )}
            </Stack>
            <Divider />
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              gap={2}
              mt="-10px"
            >
              {connection?.id && (
                <Button
                  sx={styles.buttonBottom}
                  color="primary"
                  variant="text"
                  //endIcon={<DeleteOutline />}
                  startIcon={<DeleteOutline />}
                  onClick={() => {
                    setCheckChanges(false);
                    handleDelete(connection.id);
                  }}
                >
                  {"Remover"}
                </Button>
              )}
              <Button
                sx={styles.buttonBottom}
                color="primary"
                variant="text"
                startIcon={<CancelOutlined />}
                // endIcon={<CloseOutlined />}
                onClick={() => {
                  checkChanges
                    ? setOpenAlertModal({
                        open: true,
                        severity: "warning",
                        text: "As alterações feitas não foram salvas. Se prosseguir com a operação as mudanças serão perdidas.",
                      })
                    : close();
                }}
              >
                {"Cancelar"}
              </Button>

              <LoadingButton
                sx={[
                  styles.buttonBottom,
                  {
                    color: theme.palette.text.primary,
                    "&:hover": {
                      backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    },
                  },
                ]}
                color="primary"
                variant="text"
                loading={loadingButton}
                //disabled={!checkChanges}
                startIcon={<SaveOutlined />}
                onClick={() => {
                  handleSave();
                  close();
                }}
              >
                {connection?.id ? "Salvar" : "Adicionar"}
              </LoadingButton>
            </Stack>
          </>
        )}
      </Drawer>
    );
  }
);
export default EnlaceSideBarEasyMaps;
